// ----------------------------------------------------------------
import { createFileRoute } from '@tanstack/react-router';
import TasksPage from '@/pages/tasks';
// ----------------------------------------------------------------

/**
 * The Route component is a file route that is used to render the TasksPage component.
 * This is a route setup for '/tasks/' route.
 */
export const Route = createFileRoute('/_authenticated-layout/tasks/')({
  component: TasksPage,
});
